import type { DotTone } from "@/shared/rd";

/** Status in tables and lists: a dot and the word, never a filled pill. */
export function statusTone(value: string): DotTone {
  if (["APPROVED", "delivered", "read", "available"].includes(value)) return "green";
  if (["failed", "rejected", "REJECTED", "DISABLED"].includes(value)) return "red";
  if (["unknown", "PENDING", "partial", "unavailable", "PAUSED"].includes(value)) return "amber";
  if (["sent", "accepted", "IN_APPEAL"].includes(value)) return "blue";
  return "grey";
}
